export default __webpack_public_path__ + "static/media/Path2252.12e1ddf0.svg";